// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__8-GI4","link":"Footer_link__Xukzp"};